(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentController', ShipmentController);

    ShipmentController.$inject = ['$scope','ShipmentGridDTO','AlertService','SingleDblClickService','ToastrService','category','ShipmentCustomService','$uibModal','Principal'];

    function ShipmentController ($scope, ShipmentGridDTO, AlertService, SingleDblClickService, ToastrService, category, ShipmentCustomService, $uibModal, Principal) {
        var vm = this;

        vm.shipments = [];
        vm.category = category;
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.createPurchaseInvoice = createPurchaseInvoice;
        vm.createSaleInvoice = createSaleInvoice;
        vm.updateShipmentFreightDetails = updateShipmentFreightDetails;
        vm.eligiblePurchaseInvoice = false;
        vm.purchInvoiceMsg = null;
        vm.eligibleSaleInvoice = false;
        vm.saleInvoiceMsg = null;

        vm.filterModel = {};
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.shipmentDateFrom = {
            opened: false
        };
        $scope.shipmentDateTo = {
            opened: false
        };
        $scope.openShipmentDateFrom = function () {
            $scope.shipmentDateFrom.opened = true;
        };
        $scope.openShipmentDateTo = function () {
            $scope.shipmentDateTo.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.shipmentDateFrom = false;
        vm.datePickerOpenStatus.shipmentDateTo = false;

        vm.fieldsMapping = {
            "shipmentNum": "shipmentNum",
            "status": "status",
            "siDate": "siDate",
            "qtyBales": "qtyBales",
            "P.Contract(s)": "contractA",
            "P.Invoice(s)": "purchaseInvoiceA",
            "saleContractNum": "saleContract",
            "saleInvoice": "saleInvoice",
            "shipmentLcNumber": "lcNumber",
            "shipmentBlNumber": "blNumber",
            "shipmentBoeRef": "boeRef",
            "shipmentBookingNumber": "shipmentBookingNumber"
        };

        vm.getShipmentFieldName = function(dtoName) {
            return vm.fieldsMapping[dtoName] || dtoName;
        };

        vm.gridOptions = {
            paginationPageSizes: [25, 50, 100, 150, 200],
            paginationPageSize: 100,
            enableFiltering: false,
            enableGridMenu: true,
            enableRowSelection: true,
            multiSelect: false,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function( gridApi ) {
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns[0].field !== 'Actions') {
                        if (sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                            vm.predicate = vm.getShipmentFieldName(sortColumns[0].field);
                            vm.reverse = sortColumns[0].sort.direction === 'asc';
                        } else {
                            vm.predicate = 'id';
                            vm.reverse = true;
                        }
                        loadAll();
                    }
                });
                gridApi.selection.on.rowSelectionChanged( $scope, function( row ) {
                    if( $scope.gridApi.selection.getSelectedRows().length === 1 ) {
                        vm.eligiblePurchaseInvoice = eligibleForPurchaseInvoice( row.entity );
                        vm.eligibleSaleInvoice = eligibleForSaleInvoice( row.entity );
                    } else {
                        vm.eligiblePurchaseInvoice = false;
                        vm.eligibleSaleInvoice = false;
                        vm.saleInvoiceMsg = null;
                        vm.purchInvoiceMsg = null;
                    }
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {
                    name: 'Actions',
                    cellTemplate: '<div style="display:table-cell; text-align: center; vertical-align:middle;width: 100px;height: 30px;">' +
                    '<button class="btn btn-primary btn-xs" ng-click="grid.appScope.rowCopyClick(row.entity)" ng-dblclick="grid.appScope.rowCopyDbClick(row.entity)">Copy</button>' +
                    '</div>',
                    width: 100,
                    visible: true
                },
                { name: 'Shipment #', field: 'shipmentNum', width: 180, visible: true },
                { name: 'Status', field: 'status', width: 150, visible: true },
                { name: 'Shipment Date', field: 'siDate', width: 150, visible: true },
                { name: 'Qty', field: 'qtyDisplay', width: 150, visible: true },
                {
                    name: 'P.Contract(s)',
                    cellTemplate: '<div class="ui-grid-multiline" style="display:table-cell">' +
                    '{{row.entity.contractA}}&nbsp;{{row.entity.contractB}}&nbsp;{{row.entity.contractC}}&nbsp;{{row.entity.contractD}}&nbsp;{{row.entity.contractE}}&nbsp;{{row.entity.contractF}}' +
                    '</div>',
                    width: 150,
                    visible: true
                },
                {
                    name: 'P.Invoice(s)',
                    cellTemplate: '<div class="ui-grid-multiline" style="display:table-cell">' +
                    '{{row.entity.purchaseInvoiceA}}&nbsp;{{row.entity.purchaseInvoiceB}}&nbsp;{{row.entity.purchaseInvoiceC}}&nbsp;{{row.entity.purchaseInvoiceD}}&nbsp;{{row.entity.purchaseInvoiceE}}&nbsp;{{row.entity.purchaseInvoiceF}}' +
                    '</div>',
                    width: 150,
                    visible: true
                },
                { name: 'S.Contract', field: 'saleContract', width: 150, visible: true },
                { name: 'S.Invoice', field: 'saleInvoice', width: 150, visible: true },
                { name: 'LC #', field: 'lcNumber', width: 150, visible: true },
                { name: 'BL #', field: 'blNumber', width: 150, visible: true },
                { name: 'BOE #', field: 'boeRef', width: 150, visible: true },
                { name: 'S.Inv NCon Val', field: 'saleNContractValue', width: 150, visible: true },
                { name: 'Booking #', field: 'shipmentBookingNumber', width: 150, visible: true },
                {
                    name: 'F.Amount',
                    cellTemplate: '<div style="display:table-cell">' +
                    '{{row.entity.fpCurrency}}&nbsp;{{row.entity.fpAmount}}' +
                    '</div>',
                    width:150,
                    visible: true
                }
            ]
        };

        initFilter();
        loadAll();
        getPrincipal();
        vm.isAgent = false;
        function getPrincipal() {
            Principal.identity().then(function(account) {
                vm.principal = account;
                vm.isAgent = vm.principal.authorities.includes('ROLE_AGENT');
                if(vm.isAgent) {
                    vm.gridOptions.columnDefs[0].visible = false; //copy shipment
                    vm.gridOptions.columnDefs[5].visible = false; //purchase contracts
                    vm.gridOptions.columnDefs[6].visible = false; //purchase invoices
                    vm.gridOptions.columnDefs[7].visible = false; //sale contract
                    vm.gridOptions.columnDefs[8].visible = false; //sale invoice
                    vm.gridOptions.columnDefs[14].visible = false; //freight amount
                }
            });
        }

        function initFilter() {
            vm.filterModel = {
                shipmentNum: '',
                siDateFrom: null,
                siDateTo: null,
                qtyBalesFrom: null,
                qtyBalesTo: null,
                lcNumber: '',
                lcBankRef: '',
                blNumber: '',
                boeRef: '',
                shipmentBookingNumber: '',
                purchaseCropYear: '',
                saleCropYear: '',
                purchaseContract: '',
                saleContract: '',
                purchaseInvoice: '',
                saleInvoice: '',
                purchaseContractGrowth: '',
                saleContractGrowth: '',
                buyer: '',
                seller: '',
                forReport: true,
                statusDraft: true,
                statusAllocated: true,
                statusScheduled: true,
                statusDraftReceived: true,
                statusShipped: true,
                statusInvoiced: true,
                statusCancelled: false,
                saleNContractAmountFrom: '',
                saleNContractAmountTo: ''
            };
        }

        function loadAll () {
            if (vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.shipments = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);

            ShipmentGridDTO.query(queryParams, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.shipments = angular.copy(data);
                vm.gridOptions.data = vm.shipments;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                $scope.gridApi.selection.clearSelectedRows();
                ToastrService.success("Successfully fetched Shipments", "Success");
            }

            function onError(error) {
                AlertService.error(error.data.message);
                ToastrService.error("Failed to fetch Shipments", "Error");
            }
        }

        function reset () {
            vm.page = 0;
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        $scope.rowSingleClick = function(row) {
            if (!$scope.copyButtonClicked) {
                SingleDblClickService.singleClick(row, 'shipment.shipment-detail', 'shipment');
            }
            $scope.copyButtonClicked = false;
        };

        $scope.rowDblClick = function(row) {
            if(vm.isAgent) {
                if (!$scope.copyButtonClicked) {
                    ShipmentCustomService.returnBoolAgentPartOfPurchase(row.entity.id).then(function(data) {
                        if(data.data === true) {
                            SingleDblClickService.dblClick(row, 'shipment.edit-agent', 'shipment');
                        } else {
                            SingleDblClickService.dblClickAgent(row, 'shipment.shipment-detail', 'shipment');
                        }
                    }, function(error) {
                        ToastrService.error("Something went wrong","Error");
                    });
                }
                $scope.copyButtonClicked = false;
            } else {
                if (!$scope.copyButtonClicked) {
                    SingleDblClickService.dblClick(row, 'shipment.edit', 'shipment');
                }
                $scope.copyButtonClicked = false;
            }
        };

        $scope.rowCopyClick = function(row) {
            $scope.copyButtonClicked = true;
            $uibModal.open({
                templateUrl: 'app/entities/shipment/dialog/shipment-copy-dialog.html',
                controller: 'ShipmentCopyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'app-modal-xl',
                resolve: {
                    entity: function () {
                        return row;
                    }
                }
            }).result.then(function () {
                $scope.copyButtonClicked = false;
                vm.loadAll();
            }, function () {
                $scope.copyButtonClicked = false;
                vm.loadAll();
            });
        };

        $scope.rowCopyDbClick = function(row) {
            // TODO what to do with double click on copy button
            $scope.rowCopyClick(row);
        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };

        function createPurchaseInvoice() {
            var selectedShipment = $scope.gridApi.selection.getSelectedRows()[0];
            var route = 'invoice-purchase.new';
            var data = {
                heading: 'Create Purchase Invoice',
                route: route,
                id: selectedShipment.id,
                param: {
                    shipmentId: selectedShipment.id
                }
            };
            vm.createTab(data);
        }

        function createSaleInvoice() {
            var selectedShipment = $scope.gridApi.selection.getSelectedRows()[0];
            var route = 'invoice-sale.new';
            var data = {
                heading: 'Create Sale Invoice',
                route: route,
                id: selectedShipment.id,
                param: {
                    shipmentId: selectedShipment.id
                }
            };
            vm.createTab(data);
        }

        function updateShipmentFreightDetails() {
            var selectedShipment = $scope.gridApi.selection.getSelectedRows()[0];
            $uibModal.open({
                templateUrl: 'app/entities/shipment/dialog/shipment-freight-dialog.html',
                controller: 'ShipmentFreightDialogController',
                controllerAs: 'vm',
                windowClass: 'app-modal-xl',
                resolve: {
                    entity: function() {
                        return selectedShipment;
                    }
                }
            }).result.then(function(retVal) {
                // var index = vm.shipments.indexOf(selectedShipment);
                // selectedShipment.shipmentFreightPaymentDate = retVal.freightPaymentDate;
                // selectedShipment.shipmentFreightInvoiceAmountDisplay = retVal.freightInvoiceAmountDisplay;
                // vm.shipments[index] = selectedShipment;
                // vm.gridOptions.data = vm.shipments;
            });
        }

        function eligibleForPurchaseInvoice( data ) {
            vm.purchInvoiceMsg = null;
            var invoiceA = false;
            var purchaseB = false;
            var invoiceB = true;
            var purchaseC = false;
            var invoiceC = true;
            var purchaseD = false;
            var invoiceD = true;
            var purchaseE = false;
            var invoiceE = true;
            var purchaseF = false;
            var invoiceF = true;
            var msg = "Not Eligible For New Purchase Invoice";
            if( data.contractAId === null ) { //purchase contract a doesn't exist -- not eligible
                msg = msg + "<br />-- No Purchase Contract";
            } else { //purchase contract a exists
                if( data.purchaseInvoiceAId !== null ) { //purchase invoice a exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractA + " Already Exists (" + data.purchaseInvoiceA + ")";
                } else { //purchase invoice doesn't exist -- eligible
                    invoiceA = true;
                }
            }
            if( data.contractBId !== null ) { //purchase contract b exists
                purchaseB = true; //set flag to true
                if (data.purchaseInvoiceBId !== null) { //purchase invoice b exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractB + " Already Exists (" + data.purchaseInvoiceB + ")";
                    invoiceB = false;
                } else { //purchase invoice doesn't exist -- eligible
                    invoiceB = true;
                }
            }
            if( data.contractCId !== null ) { //purchase contract c exists
                purchaseC = true; //set flag to true
                if( data.purchaseInvoiceCId !== null ) { //purchase invoice c exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractC + " Already Exists (" + data.purchaseInvoiceC + ")";
                    invoiceC = false;
                } else { //purchase invoice c doesn't exist -- eligible
                    invoiceC = true;
                }
            }
            if( data.contractDId !== null) { //purchase contract d exists
                purchaseD = true; //set flag to true
                if( data.purchaseInvoiceDId !== null) { //purchase invoice d exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractD + " Already Exists (" + data.purchaseInvoiceD + ")";
                    invoiceD = false;
                } else { // purchase invoice d doesn't exist -- eligible
                    invoiceD = true;
                }
            }
            if( data.contractEId !== null) { //purchase contract e exists
                purchaseE = true; //set flag to true
                if( data.purchaseInvoiceEId !== null) { //purchase invoice e exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractE + " Already Exists (" + data.purchaseInvoiceE + ")";
                    invoiceE = false;
                } else { //purchase invoice e doesn't exist -- eligible
                    invoiceE = true;
                }
            }
            if(data.contractFId !== null ) { //purchase contract f exists
                purchaseF = true; //set flag to true
                if( data.purchaseInvoiceFId !== null ) { //purchase invoice f exists -- not eligible
                    msg = msg + "<br />-- Invoice For Contract " + data.contractF + " Already Exists (" + data.purchaseInvoiceF + ")";
                    invoiceF = false;
                } else { //purchase invoice f doesn't exist -- eligible
                    invoiceF = true;
                }
            }
            //need to pass at least one condition to return true
            if( ( invoiceA === true ) || //with purchase contract a & no invoice a
                ( purchaseB === true && invoiceB === true ) || //with purchase contract b & no invoice b
                ( purchaseC === true && invoiceC === true ) || //with purchase contract c & no invoice c
                ( purchaseD === true && invoiceD === true ) || //with purchase contract d & no invoice d
                ( purchaseE === true && invoiceE === true ) || //with purchase contract e & no invoice e
                ( purchaseF === true && invoiceF === true )) { //with purchase contract f & no invoice f
                vm.purchInvoiceMsg = null;
                return true;
            } else { //6 conditions above all failed
                vm.purchInvoiceMsg = msg;
                return false;
            }
        }

        function eligibleForSaleInvoice( data ) {
            vm.saleInvoiceMsg = null;
            if( data.saleContractId === null ) { //sale contract doesn't exist -- not eligible
                vm.saleInvoiceMsg = "Not Eligible For New Sale Invoice -- No Sale Contract";
                return false;
            } else { //sale contract exists
                if( data.saleInvoiceId === null ) { //no sale invoice -- eligible for new sale invoice
                    return true;
                } else { //sale invoice already exists -- not eligible
                    vm.saleInvoiceMsg = "Not Eligible For New Sale Invoice -- Already Exists (" + data.saleInvoice + ")";
                    return false;
                }
            }
        }

        vm.cleanFilter = function() {
            initFilter();
            vm.reset();
        };
    }
})();
